import React from 'react';
import './HomeWFAIRL.scss';
import BlogFeaturedTopic from '../../Blog/BlogFeaturedTopic/BlogFeaturedTopic';

/**
 * Renders the Home WFA IRL module on the homepage
 * @param {string} topic
 * @param {string} image
 * @param {boolean} isDarkImage
 * @param {array} recentTagPosts
 * @param {string} viewAllLink
 * @param {boolean} isHomepage
 * @param {boolean} isPressPreview
 * @returns {JSX.Element}
 * @constructor
 */
const HomeWFAIRL = ({
  topic,
  image,
  isDarkImage,
  recentTagPosts,
  viewAllLink,
  isHomepage = true,
  isPressPreview = false,
}) => {
  return (
    <div className="c-home-wfa-irl">
      <BlogFeaturedTopic
        isFiltering={false}
        image={image}
        topic={topic}
        recentTagPosts={recentTagPosts}
        viewAllLink={viewAllLink}
        isDarkImage={isDarkImage}
        isHomepage={isHomepage}
        isPressPreview={isPressPreview}
      />
    </div>
  );
};

export default HomeWFAIRL;
